/**
 * The Pomodoro member of the desktop bridge. The types live with the rest of
 * this app's copy of the contract in `../bridge`.
 */

import type { WoneDesktopBridge } from "../bridge";

export type {
  BreakSession,
  BreakSessionReply,
  BreakStartingMessage,
} from "../bridge";

export type PomodoroBridge = NonNullable<WoneDesktopBridge["pomodoro"]>;

/** Null in a browser, and in a shell built before the timer existed. */
export function getPomodoroBridge(
  bridge: WoneDesktopBridge | null
): PomodoroBridge | null {
  return bridge?.pomodoro ?? null;
}
